import { updateConnectorConnection } from 'api/v2/connectors/updateConnector';
import { useMutation } from 'react-query';
import type { Connector } from 'types/transactions.types';
import { createRelativeURLFromOrigin } from 'utils/helpers';

const useUpdateBankConnection = (connector: Connector) => {
  return useMutation(
    (params?: any) => {
      const { bankId, financialInstitutionSlug } = params;

      return updateConnectorConnection(connector, {
        successRedirectUri: createRelativeURLFromOrigin(),
        errorRedirectUri: createRelativeURLFromOrigin(),
        bankId,
        financialInstitutionSlug,
      });
    },
    {
      onSuccess: ({ redirectUri }) => {
        window.location.href = redirectUri;
      },
    },
  );
};

export default useUpdateBankConnection;
